var _rect, _rect2, _rect3, _text, _path, _path2, _g, _path3, _path4, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg103(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "1233\uD68C \uB85C\uB610 \uC790\uB3D9\uBC88\uD638") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    rx: 28,
    fill: "#fff8e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 80,
    width: 640,
    height: 290,
    rx: 32,
    fill: "#fff",
    stroke: "#e0a72b",
    strokeWidth: 7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 120,
    width: 210,
    height: 70,
    rx: 35,
    fill: "#0f766e"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 225,
    y: 165,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 28,
    fontWeight: 900,
    fill: "#fff"
  }, "\uC790\uB3D9 \uC0DD\uC131")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M350 155h75",
    stroke: "#0f766e",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m405 132 28 23-28 23",
    fill: "none",
    stroke: "#0f766e",
    strokeWidth: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "sans-serif",
    fontSize: 25,
    fontWeight: 900,
    textAnchor: "middle",
    fill: "#172033"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 485,
    cy: 155,
    r: 38,
    fill: "#ffd666"
  }), /*#__PURE__*/React.createElement("text", {
    x: 485,
    y: 164
  }, "6"), /*#__PURE__*/React.createElement("circle", {
    cx: 580,
    cy: 155,
    r: 38,
    fill: "#b9e6dc"
  }), /*#__PURE__*/React.createElement("text", {
    x: 580,
    y: 164
  }, "14"), /*#__PURE__*/React.createElement("circle", {
    cx: 675,
    cy: 155,
    r: 38,
    fill: "#d9ccff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 675,
    y: 164
  }, "27"), /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 270,
    r: 38,
    fill: "#d9ccff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 390,
    y: 279
  }, "31"), /*#__PURE__*/React.createElement("circle", {
    cx: 485,
    cy: 270,
    r: 38,
    fill: "#ffd666"
  }), /*#__PURE__*/React.createElement("text", {
    x: 485,
    y: 279
  }, "38"), /*#__PURE__*/React.createElement("circle", {
    cx: 580,
    cy: 270,
    r: 38,
    fill: "#b9e6dc"
  }), /*#__PURE__*/React.createElement("text", {
    x: 580,
    y: 279
  }, "44"))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150 265c25-38 75-38 100 0",
    fill: "none",
    stroke: "#172033",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m235 238 20 30-35 4",
    fill: "#172033"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 330,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 25,
    fontWeight: 800,
    fill: "#172033"
  }, "\uBB34\uC791\uC704 \xB7 \uC911\uBCF5 \uC5C6\uC74C")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg103);
export default __webpack_public_path__ + "static/media/103-자동번호.a2b36895e291b92431df0298ed9bcfcc.svg";
export { ForwardRef as ReactComponent };